import { render, staticRenderFns } from "./BlockButtons.vue?vue&type=template&id=eef0c950&scoped=true&"
import script from "./BlockButtons.vue?vue&type=script&lang=ts&"
export * from "./BlockButtons.vue?vue&type=script&lang=ts&"
import style0 from "./BlockButtons.vue?vue&type=style&index=0&id=eef0c950&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef0c950",
  null
  
)

export default component.exports